export default [
  {
    path: '/e-invoice',
    name: 'invoice-management',
    component: () =>
      import('@/views/modules/e-invoice/EInvoice.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]